<template>
  <div class="clearfix">
    <div
      class="reveal"
      ref="extendSessionModal"
      id="extendSessionModal"
      data-reveal
    >
      <div class="tender-confirm clearfix">
        <p class="confirm-header">{{ $t('warn.session.renew') }}</p>
        <div class="row align-center">
          <button
            id="confirm_ok"
            type="button"
            class="btn btn--orange"
            @click="extendSession()"
          >{{ $t('action.renew') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
import { noExtendSessionPaths } from '@/utils/regex'
import { checkStatus } from '@/api/users/request'

export default {
  name: 'ExtendSessionModal',
  methods: {
    async init () {
      if (!this.extendSessionModal) {
        this.extendSessionModal = await new Foundation.Reveal($('#extendSessionModal'), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
    },
    async openModal () {
      if (Object.values(noExtendSessionPaths).some(path => path.test(location.hash.replace('#', '')))) {
        return
      }
      await this.init()
      $('#extendSessionModal').parent().css('z-index', '1011')
      this.extendSessionModal.open()
    },
    async closeModal () {
      if (this.extendSessionModal) {
        this.extendSessionModal.close()
      }
    },
    async extendSession () {
      try {
        await checkStatus(true)
      } catch (err) {
        // do nothing
      } finally {
        this.extendSessionModal.close()
      }
    },
  },

  mounted () {
    EventBus.$on('modules_extend_session_modal_open', () => {
      this.openModal()
    })
    EventBus.$on('modules_extend_session_modal_close', () => {
      this.closeModal()
    })
  },
  destroyed () {
    EventBus.$off('modules_extend_session_modal_open')
    EventBus.$off('modules_extend_session_modal_close')
    if (this.extendSessionModal) {
      this.extendSessionModal.destroy()
    }
    $('#extendSessionModal').remove()
  },
}
</script>

<style scoped lang="scss">
@import '~styles/settings';
@import '~styles/popup';
</style>

<style lang="scss" scoped>
#extendSessionModal {
  z-index: 1020;
  width: 500px;
  font-weight: bold;
  font-size: 14px;
  .confirm-header {
    font-size: 14px;
  }
}
</style>
